import Cytoscape from 'cytoscape';
import COSEBilkent from 'cytoscape-cose-bilkent';
import React, { useContext, useEffect, forwardRef, useImperativeHandle } from 'react';
import CytoscapeComponent from 'react-cytoscapejs';
import { ProjectContext } from '../../contexts/ProjectContext';
import contextMenus from 'cytoscape-context-menus';
import '../../assets/cytoscape-context-menus.css';
import cystyle from '../../assets/cystyle.json';
import jquery from 'jquery';
import edgehandles from 'cytoscape-edgehandles';

Cytoscape.use(edgehandles);
Cytoscape.use(COSEBilkent);
// Cytoscape.use(contextMenus);
Cytoscape.use(jquery);

export const ProjectCanvas = forwardRef((props, ref) => {
    const { elements, deleteElementDialog, SelectItem, setShowNewNodeDialog, addConnection } = useContext(ProjectContext);

    let myCyRef;
    const layout = { name: 'cose-bilkent' };

    let edgehandles_defaults = {
        canConnect: function (sourceNode, targetNode) {
            // whether an edge can be created between source and target
            return !sourceNode.same(targetNode); // e.g. disallow loops
        },
        edgeParams: function (sourceNode, targetNode) {
            // for edges between the specified source and target
            // return element object to be passed to cy.add() for edge
            return {};
        },
        hoverDelay: 150, // time spent hovering over a target node before it is considered selected
        snap: true, // when enabled, the edge can be drawn by just moving close to a target node (can be confusing on compound graphs)
        snapThreshold: 50, // the target node must be less than or equal to this many pixels away from the cursor/finger
        snapFrequency: 15, // the number of times per second (Hz) that snap checks done (lower is less expensive)
        noEdgeEventsInDraw: true, // set events:no to edges during draws, prevents mouseouts on compounds
        disableBrowserGestures: true // during an edge drawing gesture, disable browser gestures such as two-finger trackpad swipe and pinch-to-zoom
    };

    useEffect(() => {
        myCyRef.on('tap', function (event) {
            var evtTarget = event.target;

            if (evtTarget === myCyRef) {
                SelectItem('x');
            } else {
                SelectItem(event.target.data().id);
            }
        });


        myCyRef.on('ehcomplete', (event, sourceNode, targetNode, addedEdge) => {
            let { position } = event;
            addConnection(sourceNode.data().id, targetNode.data().id, "PARENT", true);
        });

        myCyRef.edgehandles(edgehandles_defaults);
        myCyRef.minZoom(0.2);
        myCyRef.maxZoom(4);
        setLayout();
    }, []);


    useEffect(() => {
        //setLayout();
        var styles = getStyleForNodes();
        console.log(styles);
        console.log(cystyle);
    }, [elements]);

    const getStyleForNodes = () => {
        var nodesWithPic = elements.filter(el => { return el.data.image && el.data.image != "" });
        var style = "";
        nodesWithPic.forEach(element => {
            cystyle.push({
                selector: "node[id='" + element.data.id + "']",
                style: {
                    "background-image": element.data.image
                }
            })
        }
        );
        return style;
    }

    const setLayout = () => {
        myCyRef.layout({ name: 'cose-bilkent', animationDuration: 400 }).run();
        console.log("layout");

        // cystyle.forEach(e => {
        //     if (e.selector === "node[name='fc']") {
        //         console.log("in");
        //         e.style.shape = "rectangle";
        //         return;
        //     }
        // })
        // myCyRef.style(cystyle);
    }

    useImperativeHandle(ref, () => ({
        ConnectionStart() {
            var eh = myCyRef.edgehandles();
            eh.start(myCyRef.$('node:selected'));
        },
        setLayout,
        SelectItemOnCanvas(id) {
            if (myCyRef) {
                var typeIds = myCyRef.elements(':selected');
                typeIds.forEach((selectedId, index) => {
                    myCyRef.getElementById(selectedId.data().id).unselect();
                })
                myCyRef.getElementById(id).select();
            }
        },
        FitToSelected() {
            myCyRef.animate({
                fit: { eles: myCyRef.elements(':selected') },
                duration: 500
            });
        },
        Fit() {
            myCyRef.animate({
                fit: {},
                duration: 500
            });
        },
        ExportToPng() {
            var options = {
                full: true,
                maxWidth: 3000
            };

            var png64 = myCyRef.png(options);
            console.log(png64);
            var a = document.createElement("a");
            a.href = png64;
            a.download = "Branchout_export.png";
            a.click();
        }
    }));

    const menuAddItem = (source) => {
        setShowNewNodeDialog(true)
    }

    const delElement = (source) => {
        deleteElementDialog(source.id);
    }

    return (
        <>
            <CytoscapeComponent
                id="cy"
                container="cy"
                stylesheet={cystyle}
                cy={cy => { // Extensions and their options
                    myCyRef = cy;
                }}
                layout={layout}
                elements={elements}
                style={{ width: '100%', height: '100%', position: 'fixed' }} />

        </>
    );
});
